import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/pages/_bedtime-story.scss';

const BedtimeStory3: React.FC = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  const handleFinish = async () => {
    try {
      const response = await fetch('/api/completed-sessions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          title: 'The Magical Dream Garden',
          description: 'Completed Bedtime Story 3 session.',
          image: require('../assets/sleeping.png').default || require('../assets/sleeping.png'),
          duration: '10 min',
          type: 'bedtime-story'
        })
      });
      if (response.ok) {
        navigate(-1);
      } else {

        navigate(-1);
      }
    } catch (error) {

      navigate(-1);
    }
  };

  return (
    <div className={`bedtime-story-page ${isDarkMode ? 'dark' : ''}`}>
      <div className="bedtime-story-container">
        <header className="bedtime-story-header">
          <a
            className="bedtime-story-back-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
            title="Go back"
          >
            <span className="material-symbols-outlined">arrow_back</span>
          </a>
          <div className="bedtime-story-header-content">
            <h1 className="bedtime-story-title">The Magical Dream Garden</h1>
            <p className="bedtime-story-subtitle">A soothing bedtime story to help you drift into peaceful sleep</p>
          </div>
        </header>

        <main className="bedtime-story-main">
          <div className="bedtime-story-video-wrapper">
            <div className="bedtime-story-video-container">
              <iframe
                className="bedtime-story-video"
                src="https://www.youtube.com/embed/fgzcZWDHbMc?autoplay=0&fs=1&playsinline=1"
                title="Bedtime Story 3: The Magical Dream Garden"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <div className="bedtime-story-content">
            <p className="bedtime-story-description">
              Wander through an enchanted garden filled with glowing flowers and peaceful creatures. This dreamy story invites you to explore a realm where relaxation and wonder bloom at every turn.
            </p>
            <button 
              className="bedtime-story-finish-btn" 
              onClick={handleFinish}
            >
              <span className="material-symbols-outlined">done</span>
              <span>Mark as Complete</span>
            </button>
          </div>
        </main>
      </div>
    </div>
  );
};

export default BedtimeStory3;

